import { App as AntApp } from 'antd';
import ErrorBoundary from './components/ErrorBoundary';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { MaestroContextProvider } from './contexts/MaestroContext';

// Default theme to light (white) when none is set so all users see white theme by default
const THEME_KEY = 'theme';
if (typeof window !== 'undefined' && !localStorage.getItem(THEME_KEY)) {
  localStorage.setItem(THEME_KEY, 'light');
}

function App() {
  // Debug: Log the initial URL when App loads
  console.log('[App] Initial URL:', window.location.href);
  console.log('[App] Initial pathname:', window.location.pathname);
  
  return (
    <ErrorBoundary>
      <MaestroContextProvider>
        <AntApp>
          <HelmetProvider>
            <RouterProvider router={router} />
          </HelmetProvider>
        </AntApp>
      </MaestroContextProvider>
    </ErrorBoundary>
  );
}

export default App; 